import api from './api';

export const getHousingData = async (params = {}) => {
  const response = await api.get('/housing', { params });
  // BO DEBUG
  // console.log('getHousingData Response data: ',response.data);
  // EO DEBUG/
  return response.data;
};

export const getHousingDataById = async (id) => {
  const response = await api.get(`/housing/${id}`);
  return response.data;
};

export const createHousingData = async (formData) => {
  // console.log('formData:', formData);
  // for (let [key, value] of formData.entries()) {
  //   console.log(`formData ${key}:`, value);
  // }
  const response = await api.post('/housing', formData);
  return response.data;
};

export const updateHousingData = async (housing_id, formData) => {
  const response = await api.put(`/housing/${housing_id}`, formData);
  return response.data;
};

// export const updateHousingData = async (housing_id, formData) => {
//   const response = await api.put(`/housing/${housing_id}`, formData, {
//     headers: {
//       'Content-Type': 'multipart/form-data',
//     },
//   });
//   return response.data;
// };

export const deleteHousingData = async (id) => {
  const response = await api.delete(`/housing/${id}`);
  return response.data;
}; 

// Ambil foto berdasarkan nama file
export const getHousingPhoto = async (filename) => {
  const response = await api.get(`/housing/photo/${filename}`, {
    responseType: 'blob',
  });
  return URL.createObjectURL(response.data);
};


// export const getHousingPhotoUrl = async (filename) => {
//   if (!filename) return null;
//   const response = await api.get(`/housing/photo-url/${filename}`);
//   console.log('housingService/getHousingPhotoUrl/response.data: ', response.data);
//   return response.data;
// };

// ================= CRUD PICTURES =================

// CREATE foto untuk housing tertentu
export const createPicture = async (housingId, formData, onUploadProgress) => {
  const response = await api.post(`/housing/${housingId}/pictures`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress,
  });
  return response.data;
};

// READ semua foto untuk housing tertentu
export const getPictures = async (housingId) => {
  const response = await api.get(`/housing/${housingId}/pictures`);
  return response.data;
};

// READ satu foto by id
export const getPictureById = async (id) => {
  const response = await api.get(`/housing/pictures/${id}`);
  return response.data;
};

// UPDATE foto (ganti file / deskripsi)
export const updatePicture = async (id, formData) => {
  const response = await api.put(`/housing/pictures/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

// DELETE foto
export const deletePicture = async (id) => {
  const response = await api.delete(`/housing/pictures/${id}`);
  return response.data;
};